Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ResolverPlugin.default;
    }
});
var _interop_require_default = require("@swc/helpers/_/_interop_require_default");
var _ResolverPlugin = /*#__PURE__*/ _interop_require_default._(require("../dist/modules/FederationRuntimePlugins/ResolverPlugin.js"));
